import {
  PLACEONHOLD,
  REJECTSELLER,
} from "../../utils/constants";
import { getDefaultValueStatus } from "../../utils";
import PlaceOnHoldModal from "./placeOnHoldModal";
import RejectSellerModal from "./rejectSellerModal";

const getStatusModal = ({ status, selectedStatus, handlers }) => {
  if(getDefaultValueStatus(status) === selectedStatus) return null;
  switch (selectedStatus) {
    case REJECTSELLER:
      return <RejectSellerModal flag={selectedStatus} handlers={handlers} />;

    case PLACEONHOLD:
      return <PlaceOnHoldModal flag={selectedStatus} handlers={handlers} />;

    default:
      return null;
  }
};

export default getStatusModal;